<template>
  <div style="height: 100%">
    <div id="qymap"></div>
    <div id="qytable">
      <Table
        border
        :columns="columns"
        :data="tableData"
        no-data-text="<div class='table-no-data'></div>"
        :height="utils.setTableHeight(100)"
      >
      </Table>
    </div>
  </div>
</template>
<script>
var map;
var markers = [];
var lineGroups = [];
import axios from "axios";
export default {
  data() {
    return {
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "收集站",
          key: "name",
          minWidth: 100,
          maxWidth: 200,
        },
        {
          title: "清运日期",
          key: "jobDate",
          render: (h, data) => {
            return h("div", this.utils.time(data.row.jobDate, "yymmdd"));
          },
          minWidth: 90,
          maxWidth: 130,
        },
        {
          title: "进入时间",
          key: "mmm",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "离开时间",
          key: "nnn",
          minWidth: 130,
          maxWidth: 200,
        },
        {
          title: "次数",
          key: "num",
          minWidth: 60,
          maxWidth: 130,
        },
        {
          title: "车辆",
          key: "carNo",
          minWidth: 80,
          maxWidth: 130,
        },
        {
          title: "司机",
          key: "driver",
          minWidth: 80,
          maxWidth: 130,
        },
      ],
      tableData: [],
      searchItem: {
        lineId: 0,
        //pageNumber: 0,
        //pageSize: 0,
        jobDate: "",
      },
      stations: [],
    };
  },
  methods: {
    reachData(v) {
      this.stations = v.stations;
      this.item = v;
      this.gMap(v.stations);
      this.searchItem.lineId = v.lineId;
      this.searchItem.ruleLineId=v.ruleLineId;
      this.searchItem.scheduleId = v.scheduleId;
      this.searchItem.jobDate = v.jobDate;

      this.getList();
      this.getLine();
    },
    gMap(v) {
      var that = this;
      map = new AMap.Map("qymap", {
        resizeEnable: true,
        //center: point,
        zoom: 13,
        defaultCursor: "",
      });

      map.on("complete", function (ev) {
        that.showcars(v);
      });
    },
    showcars(data_info) {
      map.remove(markers);
      markers = [];
      var abc = {
        1: "ljt1",
        0: "ljt2",
      };
      for (var i = 0, marker; i < data_info.length; i++) {
        var icon = new AMap.Icon({
          size: new AMap.Size(24, 24), // 图标尺寸
          image: "static/" + abc[data_info[i].status] + ".png", // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 24), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        marker = new AMap.Marker({
          map: map,
          position: [data_info[i].x, data_info[i].y],
          icon: icon,
          offset: new AMap.Pixel(-12, -12),
          zIndex: 1000,
        });
        marker.setLabel({
          content: "<div>" + data_info[i].name + "</div>",
          offset: new AMap.Pixel(26, 6),
        });

        markers.push(marker);
      }
      map.setFitView();
      //infoWindow.on("close", alert('关闭'));
    },
    getList() {
      this.utils.loading(this, "加载中");

      axios({
        method: "post",
        url: axios.gc + "/scheduleHisCollect/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;

        for (let i = 0; i < data.length; i++) {
          //data[i].inTimes='"a1"|"b1","a2"|"b2"'
          data[i].carNo = this.item.carNo;
          data[i].driver = this.item.driver;
          this.tableData.push(data[i]);
          var b = data[i].inTimes != null ? data[i].inTimes.split(",") : "";
          //b=[111|222,333|444];
          data[i].mmm = "";
          data[i].nnn = "";
          for (const m in b) {
            var aa = b[m].split("|");
            data[i].mmm += (m == 0 ? "" : " / ") + aa[0];
            data[i].nnn += (m == 0 ? "" : " / ") + aa[1];
          }
          for (const j in this.stations) {
            if (data[i].collectId == this.stations[j].id) {
              data[i].name = this.stations[j].name;
            }
          }
        }
        this.tableData = data;
      });
    },
    getLine() {
      this.utils.loading(this, "加载中");
      axios({
        method: "post",
        url: axios.rule + "/route/item",
        data: { id: this.searchItem.ruleLineId },
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;
        this.showline(data);
      });
    },
    showline(m) {
      var v = [m];
      map.remove(lineGroups);
      // lineGroups
      var polyArrs = [];
      var paths = [];
      for (var i = 0; i < v.length; i++) {
        var add = [];
        for (const j in v[i].coordList) {
          var dd = v[i].coordList[j];
          var small = new AMap.LngLat(dd.x, dd.y);
          add.push(small);
        }
        paths.push(add);
        // 创建线实例
        var polyline = new AMap.Polyline({
          path: paths[i],
          borderWeight: 4,
          strokeWeight: 4,
          strokeColor: "#1e93c9",
        });
        polyArrs.push(polyline);
      }
      lineGroups = new AMap.OverlayGroup(polyArrs);
      map.add(lineGroups);
      map.setFitView();
    },
  },
  mounted() {
    //this.gMap();
  },
};
</script>
<style>
#qymap {
  width: calc(100% - 750px);
  float: left;
  height: 100%;
}
#qytable {
  width: 750px;
  float: left;
}
</style>


// WEBPACK FOOTER //
// src/components/garbage/ljqymx.vue